var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "guest-treatment-selector form",
      attrs: { "aria-labelledby": "guest-" + _vm.guestKey + "-title" },
    },
    [
      _c(
        "h3",
        {
          staticClass: "guest-treatment-selector__title",
          attrs: { id: "guest-" + _vm.guestKey + "-title" },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.tc("spaSoft.step1.guestTimeDateSelection.guestFieldLabel", {
                  guestNumber: Number(_vm.guestKey) + 1,
                })
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.guestData.selectedTreatments &&
      _vm.guestData.selectedTreatments.length > 0
        ? _c("SelectedTreatmentsList")
        : _vm._e(),
      _vm._v(" "),
      _vm.showTreatmentDropdown
        ? [
            _c(
              "div",
              {
                staticClass: "guest-treatment-selector__add-treatment-label",
                attrs: { id: "guest-" + _vm.guestKey + "-subtitle" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.tc(
                        "spaSoft.step1.guestTimeDateSelection.guestSubtitle"
                      )
                    ) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex-grid-3-col" }, [
              _c("div", { staticClass: "input dropdown" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedTreatmentCategory,
                        expression: "selectedTreatmentCategory",
                      },
                    ],
                    ref: "guest-" + _vm.guestKey + "-treatment-category",
                    attrs: {
                      id: "guest-" + _vm.guestKey + "-treatment-category",
                      name: "guest-" + _vm.guestKey + "-treatment-category",
                      "data-field-type": "DropdownList",
                      "aria-labelledby":
                        "guest-" + _vm.guestKey + "-treatment-label",
                      "aria-describedby": "guest-" + _vm.guestKey + "-subtitle",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedTreatmentCategory = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.validCategories, function (treatmentCategory) {
                    return _c(
                      "option",
                      {
                        key: treatmentCategory.spaSoftId,
                        domProps: { value: treatmentCategory },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(treatmentCategory.title) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "floating select-label",
                    attrs: {
                      id: "guest-" + _vm.guestKey + "-treatment-label",
                      for: "guest-" + _vm.guestKey + "-treatment-category",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.tc(
                            "spaSoft.step1.guestTimeDateSelection.treatmentType"
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.availableTreatmentsList.length
        ? _c("TreatmentsList", {
            attrs: {
              items: _vm.availableTreatmentsList,
              "current-guest": _vm.guestKey,
              "selected-category": _vm.selectedCategoryTitle,
              "aria-labelledby": "guest-" + _vm.guestKey + "-title",
            },
            on: {
              "treatment-selected": function ($event) {
                _vm.selectedTreatmentCategory = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("hr", { staticClass: "spacer" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }